const OVERRIDE_TENANT_KEY = "overrideTenantId";

/**
 * Returns the active override tenant id, or null when none is set.
 * A stored literal `'null'` is treated as "no override".
 */
export const getOverrideTenantId = (): string | null => {
  const value = localStorage.getItem(OVERRIDE_TENANT_KEY);
  return value && value !== "null" ? value : null;
};

/**
 * Sets (or clears, when passed null) the override tenant id in localStorage.
 */
export const setOverrideTenantId = (tenantId: string | null): void => {
  if (tenantId) localStorage.setItem(OVERRIDE_TENANT_KEY, tenantId);
  else localStorage.removeItem(OVERRIDE_TENANT_KEY);
};

/**
 * True when an override tenant is currently active (user is "switched").
 */
export const isUserSwitched = (): boolean => getOverrideTenantId() !== null;
